import styled from 'styled-components';
import { IonCard } from '@ionic/react';

export const SectionTitle = styled.h2`
	color: #257226;
	font-size: 1.8rem;
	font-weight: 500;
	font-family: var(--title-font);
	margin: 0 0 5px;
	line-height: 1;
	
`;

interface CardProps {
	$height: number;
}

export const Card = styled(IonCard)`
	/* background-color: green; */
	box-shadow: 0 4px 8px rgba(40, 54, 24, 0.26);
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	position: relative;
	margin: 0 0 10px;
	border-radius: 1.25rem;
	height: ${(props: CardProps) =>
		props.$height ? `${props.$height}px` : ''};
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center center;
		position: absolute;
		inset: 0;
	}
	a {
		width: 100%;
		height: 100%;
		text-decoration: none;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
	}
	/* ion-card-header {
		background-color: unset;
		h3 {
			color: #fff;
			font-size: 1.4rem;
			font-family: var(--title-font);
			font-variation-settings: 'STYL' 0, 'wght' 500;
			margin: 4px 0 4px;
		}
		ion-card-subtitle,
		p {
			margin: 0;
			font-size: 0.8rem;
			font-weight: 300;
			text-transform: none;
			color: #fff;
		}
	} */
`;

interface GradientRotation {
	$degs?: number;
}

export const Gradient = styled.div`
	position: absolute;
	inset: 0;
	pointer-events: none;
	background-image: ${(props: GradientRotation) =>
		props.$degs
			? `
		linear-gradient(
			${props.$degs}deg,
			rgba(37, 114, 38, 1) 10%,
			rgba(37, 114, 38, 0) 35%
		);
		`
			: `
		linear-gradient(
			0deg,
			rgba(37, 114, 38, 1) 10%,
			rgba(37, 114, 38, 0) 49%
		);
		`};
`;

export const Wash = styled.div`
	position: absolute;
	inset: 0;
	background-color: var(--ion-color-primary);
	mix-blend-mode: multiply;
	opacity: 0.7;
`;

export const BGTest = styled.div`
	position: absolute;
	inset: 10px 0 0 0;
	z-index: -2;
	/* opacity: 0.2; */
	display: flex;
	align-items: center;
	justify-content: center;
	/* transform: rotate(180deg); */
	overflow: hidden;
	svg {
		path {
			stroke: #1c4220;//var(--ion-color-step-900);
		}
	}
`;
